import React from 'react';
import { useTranslation } from 'react-i18next';
import { alpha } from '@mui/material/styles';
import { Box, Typography, Paper, Skeleton } from '@mui/material';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';


const colors = {
  blue: "#0792F9",
  green: "#51B948",
  red: "#F0505A",
  purple: "#C938E7",
  yellow: "#EEC643"
}

export default function KpiCard({
  color='blue',
  label='',
  value,
  Icon=LeaderboardIcon,
  loading=false
}) {
  const [t] = useTranslation();
  const colorSelected = colors[color];

  return (
    <>
      { loading ?
        (
          <Skeleton height="96px" variant="rounded" animation="wave"/>
        )
        :(
          <Paper sx={{ backgroundColor: alpha(colorSelected, 0.1), p: 2, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Icon
                fontSize='large'
                sx={{ color: colorSelected, fontSize: '3rem' }}
              />

              <Typography variant='h4' sx={{ color: colorSelected, fontWeight: 600 }}>
                {value}
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant='subtitle1' sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                {t(label)}
              </Typography>
            </Box>

          </Paper>
        )
      }
    </>
  );
}
